import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/icon/error.png'
import _imports_1 from '@/assets/image/icon/success.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "flex ter" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  width: "22",
  height: "22",
  draggable: false
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  width: "22",
  height: "22",
  draggable: false
}
const _hoisted_9 = {
  key: 2,
  class: "ml_20"
}
const _hoisted_10 = {
  key: 0,
  class: "content-dec"
}
const _hoisted_11 = {
  key: 1,
  class: "content-dec"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = {
  key: 0,
  class: "ml_20"
}
const _hoisted_15 = { class: "mt_5" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "ml_5" }
const _hoisted_20 = { class: "dialog-footer" }

import { PropType, ref, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import { t, text, message, lang } from '@/plugins/i18n'
import { useRtfix } from '@/store'
import { OrderSuccessInfoDTO } from '../data'
import { ElMessage } from 'element-plus'
import { tCurrency } from '../country'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  confirmationInfo: {
    type: Array as PropType<OrderSuccessInfoDTO[]>,
    required: true
  }
},
  emits: ['update:visible', 'close'],
  setup(__props, { emit }) {

const props = __props
const code = message.code[lang]

const router = useRouter()



const orderStatus = ref(0) // 0全部失败 1全部成功 2 部分成功部分失败
let timer: any = null
watch(() => props.confirmationInfo, (val) => {
  clearTimeout(timer)
  // 只要有一条成功就算成功
  orderStatus.value = val.every((v: any) => v.success) ? 1 : val.every((v: any) => !v.success) ? 0 : 2
  if (orderStatus.value) {
    // 5s后跳转订单详情
    timer = setTimeout(() => {
      router.push(useRtfix('OrderInfo', { params: { id: props.confirmationInfo[0].platformOrderId } }))
      emit('update:visible', false)
    }, 15000)
  }
}, {
  deep: true
})
// const arr = [
//   {
//     platformOrderId: 1674704588357267458,
//     platformOrderNo: 'D2C23063005000010',
//     estimatedTotalOrderPrice: 10,
//     totalFreezeAmount: 10,
//     success: false,
//     message: '同一个订单只能存在一个OEM商品下单'
//   },
//   {
//     platformOrderId: 1674694571034013697,
//     platformOrderNo: 'D2C23063004000009',
//     estimatedTotalOrderPrice: 10,
//     totalFreezeAmount: 10,
//     success: false,
//     message: '同一个寻源单不能同时下大货和样品',
//   }
// ]

const jumpPage = (item: OrderSuccessInfoDTO) => {
  router.push(useRtfix('OrderInfo', { params: { id: item.platformOrderId } }))
}
const close = () => {
  emit('update:visible', false)
  clearTimeout(timer)
}
const backIndex = () => {
  close()
  emit('close')
  // router.push('/')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    width: "450px",
    "model-value": __props.visible,
    "close-on-click-modal": false,
    "custom-class": "confirmmationModal",
    "before-close": close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_20, [
        _createVNode(_component_el_button, {
          onClick: backIndex,
          style: {"margin-right":"10px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('留在购物车')), 1)
          ]),
          _: 1
        }),
        (__props.confirmationInfo.length === 1 && orderStatus.value !== 0)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: _unref(useRtfix)('OrderInfo', { params: { id: __props.confirmationInfo[0]?.platformOrderId } })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('查看订单详情')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
              ]),
              _: 1
            }))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (orderStatus.value === 0)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_unref(t)('下单失败')), 1))
            : (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_unref(t)('下单成功')), 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (orderStatus.value === 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : (_openBlock(), _createElementBlock("img", _hoisted_8)),
          (__props.confirmationInfo.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (orderStatus.value === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('订单已生成，生成订单信息如下请随时关注订单动态')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (orderStatus.value === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_unref(t)('订单已生成，部分订单支付失败，')) + " ", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.confirmationInfo.filter((i) => !i.success), (item, index) => {
                        return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item.message
              ? _unref(t)(item?.message) : ''), 1))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(t)('下单失败')) + "，" + _toDisplayString(__props.confirmationInfo[0].code ? _unref(code)[__props.confirmationInfo[0].code] ??
              _unref(t)(__props.confirmationInfo[0].message ?? '') : _unref(t)(__props.confirmationInfo[0].message ?? '')), 1))
              ]))
            : (__props.confirmationInfo.length === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (orderStatus.value === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", null, _toDisplayString(__props.confirmationInfo[0].estimatedTotalOrderPrice === __props.confirmationInfo[0].totalFreezeAmount ?
              _unref(t)('订单已生成，请随时关注订单动态') : _unref(t)('最新价格为X元').replace('X',
                String(__props.confirmationInfo[0]?.totalFreezeAmount)).replace('元', _unref(tCurrency)('元'))), 1),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('15s后跳转订单详情')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(t)('下单失败')) + "，" + _toDisplayString(__props.confirmationInfo[0].code ? _unref(code)[__props.confirmationInfo[0].code] ??
              _unref(t)(__props.confirmationInfo[0].message ?? '') : _unref(t)(__props.confirmationInfo[0].message ?? '')), 1))
                ]))
              : _createCommentVNode("", true)
        ]),
        (__props.confirmationInfo.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.confirmationInfo.filter((v) => v.success), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "ml_45 mt_10 color-blue",
                  onClick: ($event: any) => (jumpPage(item))
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.platformOrderNo), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('支付成功')), 1)
                ], 8, _hoisted_18))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})